import { render, staticRenderFns } from "./SendMailDialog.vue?vue&type=template&id=703db2f7"
import script from "./SendMailDialog.vue?vue&type=script&lang=js"
export * from "./SendMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports